import IconClose from '@mui/icons-material/Close'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import LinearProgress from '@mui/material/LinearProgress'
import Tooltip from '@mui/material/Tooltip'

type Props = {
    title?: string
    children: React.ReactNode
    actions?: React.ReactNode | React.ReactNode[]
    isSubmitting?: boolean
    onClose: () => void
    spacing?: number
}

export default function NewDialog(props: Readonly<Props>) {
    const { title, children, actions = [], onClose, isSubmitting = false, spacing = 4 } = props

    return (
        <Dialog maxWidth="lg" fullWidth={true} open>
            {title ? <DialogTitle>{title} </DialogTitle> : null}
            <Tooltip title="Close" aria-label="Close">
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    disabled={isSubmitting}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <IconClose />
                </IconButton>
            </Tooltip>
            {isSubmitting ? <LinearProgress /> : null}
            <DialogContent
                dividers
                sx={{
                    overflow: 'visible',
                }}
            >
                <Grid container spacing={spacing} size={12}>
                    {children}
                </Grid>
            </DialogContent>
            <DialogActions>{actions}</DialogActions>
        </Dialog>
    )
}
